import React, { useEffect, useState, useCallback, memo } from "react";
import styles from "./HomeNoJugador.module.css";
import { useDispatch, useSelector } from "react-redux";
import Feed from "../Feed/Feed.jsx";
import Otro from "../Otro/Otro.jsx";
import Listas from "./componentes/Listas/Listas.jsx";
import NavSecond from "../../sharedComponents/NavSecond/NavSecond.jsx";
import { getListas, getEntrenamientos } from "../../actions/index.js";

const Home = ({
  inVisitor,
  dispacherPublicaciones,
  inAmigos,
  allJugadores,
  listas,
  dispatcherAmigos,
  noticias,
  publicacionView,
  seguir,
  isMobile,
}) => {
  const dispatch = useDispatch();
  const publicaciones = useSelector((state) => state.allPublicaciones);
  const userPublicaciones = useSelector((state) => state.userPubliaciones);
  const [isVisitorBool, setIsVisitorBool] = useState(false);
  const [showNavSecond, setShowNavSecond] = useState(true);
  const [displayShow, setDisplayShow] = useState("MÉTRICAS");

  const dataUserLocal = JSON.parse(localStorage.getItem("dataUser"));

  useEffect(() => {
    dispacherPublicaciones();
    dispatch(getListas(dataUserLocal.id));
    dispatch(getEntrenamientos(dataUserLocal.id));
  }, [dataUserLocal.id]);

  const handleDisplayShow = (display) => {
    setDisplayShow(display);
  };


  console.log("isMobile", isMobile);
  console.log("user", dataUserLocal);

  return (
    <>
      {isMobile ? (
        <div className={styles.conteiner}>
          <div
            className={styles.leftContainer}
            style={{ display: displayShow === "MÉTRICAS" ? "flex" : "none" }}
          >
            <Otro
              inAmigos={inAmigos}
              user={dataUserLocal}
              isVisitorBool={isVisitorBool}
            />
          </div>

          <div
            className={styles.subContainer}
            style={{ display: displayShow === "RECLUTAMIENTO" ? "flex" : "none" }}
          >
            <Listas
              allJugadores={allJugadores}
              listas={listas}
              dispatcherAmigos={dispatcherAmigos}
              inVisitor={inVisitor}
              setShowNavSecond={setShowNavSecond}
            />
          </div>

          <div
            className={styles.subContainer}
            style={{ display: displayShow === "SOCIAL" ? "flex" : "none" }}
          >
            <Feed
              user={dataUserLocal}
              publicaciones={publicaciones}
              inVisitor={inVisitor}
              userPublicaciones={userPublicaciones}
              noticias={noticias}
              publicacionView={publicacionView}
              seguir={seguir}
            />
          </div>

          {showNavSecond && (
            <div className={styles.navSecond}>
              <NavSecond
                handleDisplayShow={handleDisplayShow}
                displayShow={displayShow}
                user={dataUserLocal}
                isVisitor={false}
              />
            </div>
          )}
        </div>
      ) : (
        <div className={styles.conteiner}>
          <div className={styles.leftContainer}>
            <Otro
              inAmigos={inAmigos}
              user={dataUserLocal}
              isVisitorBool={isVisitorBool}
            />
          </div>

          <div className={styles.subContainer}>
            <Listas
              allJugadores={allJugadores}
              listas={listas}
              dispatcherAmigos={dispatcherAmigos}
              inVisitor={inVisitor}
              setShowNavSecond={setShowNavSecond}
            />
          </div>

          <div className={styles.subContainer}>
            <Feed
              user={dataUserLocal}
              publicaciones={publicaciones}
              inVisitor={inVisitor}
              userPublicaciones={userPublicaciones}
              noticias={noticias}
              publicacionView={publicacionView}
              seguir={seguir}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default memo(Home);
